import React, { Suspense } from 'react';
import { ILiveblog } from '@sky-it-cmscomposer/liveblog-design-system';

import { validateModel } from '../../utils/props-validator';
import { IComponentModel } from '../../typings/common-types';
import HtmlWrapper from '../html-wrapper/html-wrapper';

const LiveblogCardWrapper = React.lazy(() => import('./liveblog-card'));

interface IDynamicLiveblogCardWrapper extends IComponentModel<ILiveblog | {}> {
    model?: ILiveblog | {};
    query?: unknown;
    live?: boolean;
}

const DynamicLiveblogCard: React.FC<IDynamicLiveblogCardWrapper> = ({
    /* istanbul ignore next: default value on mandatory field */ model = {},
    /* istanbul ignore next: default value */ query = {},
    /* istanbul ignore next: default value */ children = null,
    /* istanbul ignore next: default value */ live = false,
}) => (
    <Suspense fallback={<HtmlWrapper html={children} />}>
        <LiveblogCardWrapper initialModel={validateModel(model) as ILiveblog} query={validateModel(query)} live={live} />
    </Suspense>
);

/**
 * YOU need to specify default props to be derived from web-component attributes
 */
DynamicLiveblogCard.defaultProps = {
    children: null,
    model: {} as ILiveblog,
    query: {},
    live: false,
};

export default DynamicLiveblogCard;
